export const DEFAULT_LOCALE = "default";
export const FALLBACK_LOCALE = "en";
export const LT_LOCALE = "lt";
